export interface UploadPeriod {
  eraYear: number;
  revisionMonth: number;
}

const REMUNERATION = '基準報酬決定通知書';

/** Fields the upload API needs, taken from the confirmed read result. */
export function readUploadPeriod(input: {
  documentTypeLabel: string;
  person: string;
  yearLabel: string;
  revisionLabel: string;
}): UploadPeriod | null {
  const documentType = input.documentTypeLabel.trim();
  if (!documentType || !input.person.trim()) return null;
  const yearMatch = input.yearLabel.trim().match(/^令和(\d{1,2})年$/);
  if (!yearMatch) return null;
  const eraYear = Number(yearMatch[1]);
  if (eraYear < 1 || eraYear > 99) return null;

  const revision = input.revisionLabel.trim();
  if (!revision) {
    if (documentType === REMUNERATION) return null;
    return { eraYear, revisionMonth: 0 };
  }
  const revisionMatch = revision.match(/^令和(\d{1,2})年(\d{1,2})月$/);
  if (!revisionMatch || documentType !== REMUNERATION) return null;
  const revisionMonth = Number(revisionMatch[2]);
  if (revisionMonth < 1 || revisionMonth > 12) return null;
  return { eraYear, revisionMonth };
}
